import { Component } from '@angular/core';

@Component({
  selector: 'app-envelope-audit',
  templateUrl: './envelope-audit.component.html',
  styleUrls: ['./envelope-audit.component.scss']
})
export class EnvelopeAuditComponent {

}
